'use client';

import { usePathname } from 'next/navigation';

function useActivePath(targetPath) {
  const pathname = usePathname();

  return pathname.startsWith(targetPath);
}

export default useActivePath;
